// Mirrors the desktop "Analyze FIR" page's case type options exactly
// (src/components/UploadDocument.js) so submitted values stay consistent
// across web and mobile.
export const CASE_TYPES = [
  'Abduction',
  'Cheating',
  'Copyright Act',
  'Criminal Trespass',
  'Cybercrime',
  'Dacoity',
  'Prevention of Damage to Public Property Act',
  'Dowry Death',
  'Explosive Substances Act',
  'Extortion',
  'Gang Rape',
  'Grievous Injury',
  'Illegal Arms Possession',
  'Liquor Smuggling (Excise Act)',
  'Matrimonial',
  'Murder',
  'Narcotics',
  'POCSO',
  'Rape',
  'Road Accident',
  'Robbery',
  'Simple Injury',
  'Theft',
  'Trade Marks Act',
  'Unlawful Activities (UAPA)',
];
